document.addEventListener("DOMContentLoaded", function() {
  const mobileLeft = document.querySelector(".mobile-toggle-wrapper");
  const footer = document.querySelector("footer"); // adjust if footer uses another tag/class
  
  if (!mobileLeft || !footer) return;

  function handleScroll() {
    if (window.innerWidth <= 1067) {
      const scrolledPast = window.scrollY > window.innerHeight * 0.3;

      // Footer position
      const footerTop = footer.getBoundingClientRect().top;
      const viewportHeight = window.innerHeight;

      // True if footer is entering the viewport
      const isInFooter = footerTop < viewportHeight;

      if (scrolledPast && !isInFooter) {
        mobileLeft.classList.add("visible");
      } else {
        mobileLeft.classList.remove("visible");
      }
    }
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();
});
